import React, { useEffect, useRef } from 'react';
import anime from 'animejs';
import useDevMode from '../devmode/usedevmode';
import './index.scss';

const MobileMessages = () => {
    const messagesRef = useRef(null);
    const { enterDevMode } = useDevMode();
    const hasRun = useRef(false);

    useEffect(() => {
        
        if (hasRun.current) return;
        hasRun.current = true;

        const messagesEl = messagesRef.current;
        const typingSpeed = 20;
        const loadingText = '<b>•</b><b>•</b><b>•</b>';
        let messageIndex = 0;

        
        const getGreeting = () => {
            const hour = new Date().getHours();
            if (hour >= 5 && hour < 12) return 'Have a great morning!';
            if (hour >= 12 && hour < 17) return 'Have a great afternoon!';
            if (hour >= 17 && hour < 22) return 'Have a good evening!';
            return 'Have a good night!';
        };

        

        const messages = [
            'Hey there 👋',
            "I'm Khwahish.",
            'My full interactive portfolio is designed specifically for PCs and laptops',
            'I\'d love for you to check it out on a larger screen when you get the chance!',
            'However, if you\'re a fellow developer, you can access the terminal version right here:',
            '<a class="dev-trigger">Initialize Terminal Environment</a>',
            getGreeting()
        ];

        
        messagesEl.addEventListener('click', (e) => {
            if (e.target.classList.contains('dev-trigger')) {
                enterDevMode();
            }
        });

        const createBubbleElements = (message, position) => {
            const bubbleEl = document.createElement('div');
            const messageEl = document.createElement('span');
            const loadingEl = document.createElement('span');

            bubbleEl.classList.add('bubble', 'is-loading', 'cornered', 'left');
            messageEl.classList.add('message');
            loadingEl.classList.add('loading');

            messageEl.innerHTML = message;
            loadingEl.innerHTML = loadingText;

            bubbleEl.appendChild(loadingEl);
            bubbleEl.appendChild(messageEl);
            bubbleEl.style.opacity = '0';

            return { bubble: bubbleEl, message: messageEl, loading: loadingEl };
        };

        const getDimensions = (elements) => {
            const messageW = elements.message.offsetWidth + 2;
            const messageH = elements.message.offsetHeight;
            const messageS = window.getComputedStyle(elements.bubble);
            const paddingTop = Math.ceil(parseFloat(messageS.paddingTop));
            const paddingLeft = Math.ceil(parseFloat(messageS.paddingLeft));

            return {
                loading: { w: '60px', h: '36px' }, 
                bubble: {
                    w: `${messageW + paddingLeft * 2}px`,
                    h: `${messageH + paddingTop * 2}px`
                },
                message: {
                    w: `${messageW}px`,
                    h: `${messageH}px`
                }
            };
        };

        const sendMessage = (message) => {
            const loadingDuration = (message.replace(/<(?:.|\n)*?>/gm, '').length * typingSpeed) + 500;
            const elements = createBubbleElements(message, 'left');

            messagesEl.appendChild(elements.bubble);
            messagesEl.appendChild(document.createElement('br'));

            const dimensions = getDimensions(elements);

            elements.message.style.display = 'block';
            elements.bubble.style.width = '0px';
            elements.bubble.style.height = dimensions.loading.h;
            elements.message.style.width = dimensions.message.w;
            elements.message.style.height = dimensions.message.h;
            elements.bubble.style.opacity = '1';

            const bubbleOffset = elements.bubble.offsetTop + elements.bubble.offsetHeight;
            if (bubbleOffset > messagesEl.offsetHeight) {
                anime({
                    targets: messagesEl,
                    scrollTop: bubbleOffset,
                    duration: 750
                });
            }

            const bubbleSize = anime({
                targets: elements.bubble,
                width: ['0px', dimensions.loading.w],
                marginTop: ['40px', 0],
                marginLeft: ['-40px', 0],
                duration: 800,
                easing: 'easeOutElastic(1, .5)'
            });

            const loadingLoop = anime({
                targets: elements.bubble,
                scale: [1.05, 0.95],
                duration: 1100,
                loop: true,
                direction: 'alternate',
                easing: 'easeInOutQuad'
            });

            anime({
                targets: elements.loading,
                translateX: ['-32px', '0px'],
                scale: [0.5, 1],
                duration: 400,
                delay: 25,
                easing: 'easeOutElastic(1, .5)',
            });

            const dotsPulse = anime({
                targets: elements.bubble.querySelectorAll('b'),
                scale: [1, 1.25],
                opacity: [0.5, 1],
                duration: 300,
                loop: true,
                direction: 'alternate',
                delay: (el, i) => (i * 100) + 50
            });

            setTimeout(() => {
                
                loadingLoop.pause();
                dotsPulse.pause();
                bubbleSize.pause();

                anime({
                    targets: elements.bubble.querySelectorAll('b'),
                    opacity: 0,
                    scale: 0,
                    duration: 300,
                    easing: 'linear',
                    update: (a) => {
                        if (a.progress >= 65 && elements.bubble.classList.contains('is-loading')) {
                            elements.bubble.classList.remove('is-loading');
                            elements.loading.style.display = 'none';

                            anime({
                                targets: elements.message,
                                opacity: [0, 1],
                                duration: 300,
                                easing: 'easeOutQuad'
                            });
                        }
                    }
                });

                anime({
                    targets: elements.bubble,
                    scale: 1,
                    width: [dimensions.loading.w, dimensions.bubble.w],
                    height: [dimensions.loading.h, dimensions.bubble.h],
                    marginTop: 0,
                    marginLeft: 0,
                    duration: 800,
                    easing: 'easeOutElastic(1, .5)',
                    begin: () => {
                        if (messageIndex < messages.length) elements.bubble.classList.remove('cornered');
                    },
                });
            }, loadingDuration - 50);
        };

        const sendMessages = () => {
            const message = messages[messageIndex];
            if (!message) return;
            sendMessage(message);
            ++messageIndex;
            setTimeout(sendMessages, (message.replace(/<(?:.|\n)*?>/gm, '').length * typingSpeed) + anime.random(900, 1200));
        };

        setTimeout(sendMessages, 500);

    }, [enterDevMode]);

    return (
        <div className="mobile-messages-wrapper">
            <div className="messages" ref={messagesRef}></div>
        </div>
    );
};

export default MobileMessages;